module.exports = __webpack_public_path__ + "img/cases-brand-avic-lazyload-321.3a7c02ca.jpg";